export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/cc3e079d4c54b89ced1891536c7354ec.svg";